/**
 *   Copyright (C) Cylergie - All Rights Reserved
 * Proprietary and confidential
 * Subject to French law on copyright
 * Unauthorized copying of this file, via any medium is strictly prohibited: https://crigen.myengie.com/copyright
 * Any request for authorization of use should be addressed by email to"mvalo.bvt@engie.com" with the subject "Copyright Statement in Source Code"
 * Written in 2024
 */

/* eslint-disable */

// Vue 3 imports
import { createApp } from 'vue';

// Import vuetify
import vuetify from '@/plugins/vuetify';

// Import Material design icons
import 'material-design-icons-iconfont/dist/material-design-icons.css';

// Import wizard styles
import '@/assets/styles/wizard.css';

// Import Highcharts
import Highcharts from 'highcharts';
// Highcharts v12+: modules self-register on import, no init call needed
import 'highcharts/modules/exporting';
import 'highcharts/modules/export-data';
import 'highcharts/modules/stock';
import HighchartsVue from 'highcharts-vue';

// Import router, store and App component
import App from './App';
import store from './store';
import router from './router';

// Import OKTA
import { oktaAuth, OktaVue } from '@/plugins/okta';

import helpers from './helpers/helper';

// Initialize Highcharts modules
// (v12+: modules self-register on import above)

const timezone = new Date().getTimezoneOffset();

Highcharts.setOptions({
  // Highcharts v12+: time-related options moved from `global` to `time`
  time: {
    timezoneOffset: timezone,
  },
  lang: {
    loading: 'Chargement...',
    months: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'],
    weekdays: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'],
    shortMonths: ['jan', 'fév', 'mar', 'avr', 'mai', 'juin', 'juil', 'aoû', 'sep', 'oct', 'nov', 'déc'],
    exportButtonTitle: 'Exporter',
    printButtonTitle: 'Imprimer',
    rangeSelectorFrom: 'Du',
    rangeSelectorTo: 'au',
    rangeSelectorZoom: 'Période',
    downloadPNG: 'Télécharger en PNG',
    downloadJPEG: 'Télécharger en JPEG',
    downloadPDF: 'Télécharger en PDF',
    downloadSVG: 'Télécharger en SVG',
    downloadCSV: 'Télécharger en CSV',
    resetZoom: 'Réinitialiser le zoom',
    resetZoomTitle: 'Réinitialiser le zoom',
    thousandsSep: ' ',
    decimalPoint: ',',
    help: 'Aide',
  },
  exporting: {
    buttons: {
      contextButton: {
        menuItems: [
          'downloadPNG',
          'downloadJPEG',
          'separator',
          'downloadCSV',
          'separator',
          {
            textKey: 'help',
            onclick: function () {
              window.open(require(`@/assets/documents/documentationUtilisateurNotice.pdf`), '_blank');
            },
          },
        ],
      },
    },
  },
});

// Create Vue 3 app
const app = createApp(App);

// Register plugins
app.use(router);
app.use(store);
app.use(vuetify);
app.use(HighchartsVue);
app.use(OktaVue, { oktaAuth });

// Add helpers as global property
app.config.globalProperties.$helpers = helpers;

// Mount app
app.mount('#app');

export default app;
